import React, { useState, useEffect, useRef } from 'react';
import { Select, Spin } from 'antd';
import { getFilterOptions } from '../../../services/ReportTemplateService';

const { Option } = Select;

const InlineFilterDropdown = ({ 
  sheetName, 
  columnName, 
  value, 
  onChange, 
  disabled = false,
  billType,
  viewMode = false
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const hasFetchedRef = useRef(false);
  const isMountedRef = useRef(true);
  
  const iec_no = localStorage.getItem('iec_no');

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchOptions = async () => {
    if (hasFetchedRef.current || loading) {
      return;
    }
    hasFetchedRef.current = true;
    setLoading(true);
    
    try {
      const response = await getFilterOptions(billType, sheetName, columnName, iec_no);
      if (response?.options && isMountedRef.current) {
        setOptions(response.options);
      }
    } catch (error) {
      console.error('Error fetching filter options:', error);
      hasFetchedRef.current = false; // Allow retry on error
    } finally {
      if (isMountedRef.current) {
        setLoading(false);
      }
    }
  };

  return (
    <Select
      placeholder="Select options"
      value={value || undefined}
      onChange={onChange}
      disabled={disabled || viewMode}
      loading={loading}
      open={viewMode ? false : undefined} // Prevent dropdown from opening in view mode
      onFocus={!viewMode ? fetchOptions : undefined}
      notFoundContent={loading ? <Spin size="small" /> : undefined}
      onDropdownVisibleChange={!viewMode ? (open) => {
        if (open && !hasFetchedRef.current) {
          fetchOptions();
        }
      } : undefined}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
      style={{ 
        width: 200, 
        marginLeft: 8 
      }}
      size="small"
      mode="multiple"
      allowClear={!viewMode}
      showSearch={!viewMode}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.children || '').toLowerCase().includes(input.toLowerCase())
      }
    >
      {/* In view mode: only show selected values as options */}
      {/* In edit mode: show selected values + full list when loaded */}
      {value && Array.isArray(value) && value.map(val => (
        <Option key={`selected-${val}`} value={val}>{val}</Option>
      ))}
      {/* Only show additional options in edit mode after loading */}
      {!viewMode && options.filter(opt => !value?.includes(opt)).map(opt => (
        <Option key={`option-${opt}`} value={opt}>{opt}</Option>
      ))}
    </Select>
  );
};

export default InlineFilterDropdown;